import { render, staticRenderFns } from "./partnerProgram.vue?vue&type=template&id=1a6f8efa&scoped=true"
import script from "./partnerProgram.vue?vue&type=script&lang=js"
export * from "./partnerProgram.vue?vue&type=script&lang=js"
import style0 from "./partnerProgram.vue?vue&type=style&index=0&id=1a6f8efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f8efa",
  null
  
)

export default component.exports